<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>
          <feather-icon icon="FilterIcon" /> Filtros
        </h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <label>Periodo</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="periodoFilter"
              :options="periodoOptions"
              class="w-100"
              label="id"
              :reduce="val => val.id"
              @input="(val) => $emit('update:periodoFilter', val)"
            >
              <!-- Options -->
              <template #option="{ clave, temp_nombre }">
                <span>
                  <b>{{ clave }}</b> - {{ temp_nombre }}
                </span>
              </template>
              <!-- Selected option -->
              <template #selected-option="{ clave, temp_nombre }">
                <div style="display: flex; align-items: baseline;">
                  <b>{{ clave }}</b><em style="margin-left: .5rem;"> - {{ temp_nombre }}</em>
                </div>
              </template>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
          >
            <label>Modalidad</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="modalidadFilter"
              :options="modalidadOptions"
              class="w-100"
              :reduce="val => val.value"
              @input="(val) => $emit('update:modalidadFilter', val)"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BOverlay,
  },
  props: {
    periodoFilter: {
      type: [Number, null],
      default: null,
    },
    modalidadFilter: {
      type: [String, null],
      default: null,
    },
    periodoOptions: {
      type: Array,
      required: true,
    },
    modalidadOptions: {
      type: Array,
      required: true,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
